import { Box, Typography } from '@mui/material';
import EnhancedTable from 'lib/designSystem/Table';
import { formatDate } from 'lib/functions/utils';
import { LaborLawFinesConsult } from 'lib/types/models';
import React from 'react';

type LaborLawFinesTableProps = {
  consult?: LaborLawFinesConsult;
};

const LaborLawFinesTable = ({ consult }: LaborLawFinesTableProps) => {
  if (!consult) return;
  const tableData = consult.data.map((r) => ({
    businessInfo: {
      primary: r.name,
      secondary: r.identifier,
    },
    fine: {
      primary: r.origin,
      secondary: r.fine,
    },
    status: r.status,
    date: r.date,
    amount: r.amount,
    currency: r.currency,
    description: r.description,
  }));
  return (
    <div>
      <EnhancedTable
        dataHeaders={[
          { key: 'businessInfo', label: 'Empresa', type: 'dual-text' },
          { key: 'fine', label: 'Multa', type: 'dual-text' },
          { key: 'status', label: 'Estado' },
          { key: 'date', label: 'Fecha', type: 'date' },
          { key: 'amount', label: 'Monto' },
          { key: 'currency', label: 'Tipo monto' },
          { key: 'description', label: 'Enunciado' },
        ]}
        data={tableData}
        rowsPerPageDefault={25}
      />
      <Box my={1} display={'flex'} flexDirection={'row'} justifyContent={'end'}>
        {consult.updatedAt ? (
          <>
            <Typography mr={1}>Última actualización:</Typography>
            <Typography fontWeight={400}>
              {formatDate(new Date(consult.updatedAt), 'dd-mm-yyyy')}
            </Typography>
          </>
        ) : (
          <Typography>No hay datos registrados para este rut</Typography>
        )}
      </Box>
    </div>
  );
};

export default LaborLawFinesTable;
